import React from 'react';

function Body(props) {
    return (
        <div className="box-list w-100 clearfix">
            <div className="square ripple">
                <div className="casino__content">
                    <img alt="Start Burst" className="casino__img" src="./images/casino/starburst.jpg" />
                </div>
            </div>
            <div className="square ripple">
                <div className="casino__content">
                    <img alt="Book Of Dead Slot" className="casino__img" src="./images/casino/bookofdeadslot.jpg" />
                </div>
            </div>
            <div className="square ripple">
                <div className="casino__content">
                    <img alt="Hot Spin" className="casino__img" src="./images/casino/hotspin.jpg" />
                </div>
            </div>
            <div className="square ripple">
                <div className="casino__content ">
                    <img alt="Mystic Mirror" className="casino__img" src="./images/casino/mysticmirror.jpg" />
                </div>
            </div>
            <div className="square ripple">
                <div className="casino__content">
                    <img alt="Book Of Gold" className="casino__img" src="./images/casino/bookofgold.jpg" />
                </div>
            </div>
            <div className="square ripple">
                <div className="casino__content">
                    <img alt="Wild APE" className="casino__img" src="./images/casino/wildape.jpg" />
                </div>
            </div>
            <div className="square ripple">
                <div className="casino__content ">
                    <img alt="Pirates Plenty" className="casino__img" src="./images/casino/piratesplenty.jpg" />
                </div>
            </div>
            <div className="square ripple">
                <div className="casino__content">
                    <img alt="Dead Alive" className="casino__img" src="./images/casino/deadalive.jpg" />
                </div>
            </div>
            <div className="square ripple">
                <div className="casino__content">
                    <img alt="Mystery Reels" className="casino__img" src="./images/casino/mysteryreels.jpg" />
                </div>
            </div>
            <div className="square ripple">
                <div className="casino__content ">
                    <img alt="Fire Joker" className="casino__img" src="./images/casino/firejoker.png" />
                </div>
            </div>
            <div className="square ripple">
                <div className="casino__content">
                    <img alt="Narcos" className="casino__img" src="./images/casino/narcos.jpg" />
                </div>
            </div>
            <div className="square ripple">
                <div className="casino__content">
                    <img alt="Netent" className="casino__img" src="./images/casino/netent.jpg" />
                </div>
            </div>
            <div className="square ripple">
                <div className="casino__content ">
                    <img alt="Secret Of The Stones" className="casino__img" src="./images/casino/secretofthestone.jpg" />
                </div>
            </div>
            <div className="square ripple">
                <div className="casino__content">
                    <img alt="Jumanji" className="casino__img" src="./images/casino/jumanji.jpg" />
                </div>
            </div>
            <div className="square ripple">
                <div className="casino__content">
                    <img alt="Mega Pyramid" className="casino__img" src="./images/casino/megapyramid.jpg" />
                </div>
            </div>
        </div>
    );
}

export default Body;
